
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buy/[...entity]",
      function () {
        return require("private-next-pages/buy/[...entity].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buy/[...entity]"])
      });
    }
  